import React, { ReactNode } from "react";

import "./style.scss";

export interface Props {
    children: ReactNode;
    className?: string;
}

/**
 * Aligns immediate children horizontally in columns.
 * On mobile, children become horizontally slideable.
 */
export const SlidingContainer = ({ children, className }: Props) => {
    const classNames = ["slidingContainer"];
    if (className) {
        classNames.push(className);
    }
    return <div className={classNames.join(" ")}>{children}</div>;
};
